"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CodeIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CodeIcon, _React$PureComponent);

  function CodeIcon() {
    _classCallCheck(this, CodeIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(CodeIcon).apply(this, arguments));
  }

  _createClass(CodeIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'code-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M11.0000316,9.00001891 C11.5530141,9.00001891 12,9.44801468 12,10.0000189 C12,10.5520042 11.5530141,11 11.0000316,11 L6.00018985,11 C5.44720735,11 5.0002215,10.5520042 5.0002215,10.0000189 C5.0002215,9.44801468 5.44720735,9.00001891 6.00018985,9.00001891 L11.0000316,9.00001891 Z M1.60032908,2.20008322 L5.60020251,5.20005485 C5.85219454,5.38905307 6.00018985,5.68505027 6.00018985,6.00004729 C6.00018985,6.31504431 5.85219454,6.61104151 5.60020251,6.80003972 L1.60032908,9.80001135 C1.42033478,9.93501007 1.21034142,10 1.00134803,10 C0.696357685,10 0.397367147,9.86201076 0.20037338,9.60001324 C-0.131616115,9.15801742 -0.0416189625,8.53102335 0.400367052,8.20002648 L3.33327424,6.00004729 L0.400367052,3.80006809 C-0.0416189625,3.46907122 -0.131616115,2.84207715 0.20037338,2.40008133 C0.531362906,1.9590855 1.15834307,1.86808636 1.60032908,2.20008322 Z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return CodeIcon;
}(_react.default.PureComponent);

exports.default = CodeIcon;
CodeIcon.defaultProps = {
  color: 'inherit'
};
CodeIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};